<template>
    <div class="hotsite-wrapper">
        <div class="banner-hotsite-container bf-camisetas">
            <div class="pos-relative text-center content-banner-bf">
                <picture>
                    <source
                        :srcset="`${$scope.CDN_IMAGES}/images/hotsites/bf-23/black-friday-camisetas-chico-rei.png?auto=compress,format&q=65`"
                        media="(min-width: 768px)"
                    />
                    <source
                        :srcset="`${$scope.CDN_IMAGES}/images/hotsites/bf-23/camisetas-black-friday-1366x768.png?auto=compress,format&q=65&w=1366&h=680&fit=crop&crop=top`"
                        media="(min-width: 577px)"
                    />
                    <source
                        :srcset="`${$scope.CDN_IMAGES}/images/hotsites/bf-23/black-frida-redm.png?auto=compress,format&q=65&w=576&h=1247&fit=crop&crop=top`"
                        media="(min-width: 412px)"
                    />
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/bf-23/camisetas-black-friday-412-740-2.png?auto=compress,format&q=65&w=412&h=660&fit=crop&crop=top`"
                        class="item-img img-responsive"
                    />
                </picture>
                <div class="center-btn-bf">
                    <a href="/promo/">
                        <p class="btn bf-camisetas" id="banner-title">Aproveitar</p></a
                    >
                </div>
            </div>
        </div>
        <div id="content-basicas">
            <div class="section-basicas">
                <div class="section-text">
                    <h1 class="my-0 mb-2">Promoções exclusivas durante a Black Friday Chico Rei</h1>
                    <span>
                        A <strong>Black Friday</strong> chegou e com ela as semanas de promoção mais
                        esperadas do ano! Essa é a sua chance de comprar nossas bolsas, mochilas,
                        canecas, posters, meias, bandeiras e muito mais por um preço único!
                    </span>
                </div>
                <div class="section-products">
                    <template v-if="true">
                        <div class="product-grid secondary">
                            <div v-for="(item, index) in mainProducts" class="product-item">
                                <a :href="item.url" target="_blank">
                                    <picture>
                                        <source :srcset="item.image" media="(min-width: 768px)" />
                                        <img
                                            :src="item.image_mobile"
                                            class="item-img img-responsive"
                                        />
                                    </picture>
                                    <div class="item-hover hidden-sm hidden-xs">
                                        <span class="text-uppercase">{{ item.text }}</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="section-basicas">
                <div class="section-text">
                    <h2 class="my-0 mb-2 h1">
                        Confira as camisetas que estão fazendo mais sucesso por aqui
                    </h2>
                    <span>
                        Ainda não sabe como aproveitar a Black Friday da Chico Rei? Fica tranquilo
                        que a gente te ajuda! Selecionamos os produtos mais vendidos por aqui para
                        você conferir e, claro, garantir os seus. Clique no banner abaixo para saber
                        mais.
                    </span>
                </div>
                <div class="section-products">
                    <a class="banner-pima" :href="bannerTopSelling.url" target="_blank">
                        <picture>
                            <source
                                :srcset="bannerTopSelling.image.desktop"
                                media="(min-width: 576px)"
                            />
                            <img
                                :src="bannerTopSelling.image.mobile"
                                alt="Banner Pima"
                                class="img-responsive center-block"
                            />
                        </picture>
                    </a>
                </div>
            </div>

            <div class="section-basicas">
                <div class="section-text">
                    <h2 class="my-0 mb-2 h1">
                        Para além das camisetas... Confira nossa linha de acessórios e itens para a
                        casa!
                    </h2>
                    <span>
                        Nosso objetivo é te ajudar a mostrar toda a sua personalidade para o mundo,
                        seja com roupas autenticas, acessórios personalizados ou dando aquele toque
                        especial na decoração do ambiente. Aproveite os preços exclusivos da Black
                        Friday e garanta seus produtos!
                    </span>
                </div>
                <div class="section-products">
                    <template v-if="true">
                        <div class="product-grid secondary">
                            <div v-for="(item, index) in mainProductsOthers" class="product-item">
                                <a :href="item.url" target="_blank">
                                    <picture>
                                        <source :srcset="item.image" media="(min-width: 768px)" />
                                        <img
                                            :src="item.image_mobile"
                                            class="item-img img-responsive"
                                        />
                                    </picture>
                                    <div class="item-hover hidden-sm hidden-xs">
                                        <span class="text-uppercase">{{ item.text }}</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="section-basicas">
                <div class="section-text">
                    <h2 class="my-0 mb-2 h1">A Chico Rei</h2>
                </div>
                <div class="section-products about-us">
                    <div>
                        <p>
                            Somos uma empresa que alia criatividade e tecnologia para impactar
                            positivamente a vida de pessoas através da arte e por meio da venda de
                            produtos feitos com responsabilidade socioambiental. Para nós, as
                            camisetas são mais do que uma peça de roupa, elas são uma forma de
                            expressar ideias, valores e crenças para o mundo.
                        </p>
                        <p>
                            Contamos com mais de meio milhão de pessoas incríveis usando nossos
                            produtos, espalhadas por mais de 3 mil cidades do Brasil. Nosso selo é
                            sinônimo de produção sustentável, qualidade e impacto social gerado a
                            cada peça vendida.
                        </p>
                    </div>
                    <div>
                        <picture>
                            <source :srcset="aboutUs.image" media="(min-width: 576px)" />
                            <img :src="aboutUs.image" class="item-img" />
                        </picture>
                    </div>
                </div>
            </div>
            <div class="section-basicas" :style="{ width: `100%` }">
                <div class="section-text">
                    <h2 class="my-0 mb-2 h1">
                        Ficou com alguma dúvida sobre a promoção? A gente te explica
                    </h2>
                    <span>
                        Selecionamos algumas das perguntas mais frequentes para te ajudar. Confira:
                    </span>
                </div>
                <div class="section-products" :style="{ alignItems: `flex-start` }">
                    <div id="description-basicas" class="my-0">
                        <div class="description-title" @click="showCoupon = !showCoupon">
                            <span>Como usar um cupom de desconto da Chico Rei?</span>
                            <span class="toggle-description">{{
                                showCoupon ? '(ocultar)' : '(mostrar)'
                            }}</span>
                        </div>
                        <div class="description-content my-2" :class="{ visible: showCoupon }">
                            <p class="my-2">
                                Se você já está cadastrado em nossa base é só escolher o cupom de
                                desconto de sua preferência e pronto, ele será inserido na sua
                                sacola de compras automaticamente.
                            </p>
                            <p class="my-2">
                                Agora, se você ainda não possui cadastro em nosso site, você só
                                precisa informar o seu endereço de e-mail após escolher o cupom.
                                Feito isso, ele também será automaticamente inserido em sua sacola
                                de compras.
                            </p>
                            <p class="my-2">
                                Mas atenção: os cupons não são cumulativos com outros descontos e
                                promoções da Chico Rei.
                            </p>
                        </div>
                    </div>
                    <div class="h-text-divider" />
                    <div id="description-basicas" class="my-0">
                        <div class="description-title" @click="showNewsletter = !showNewsletter">
                            <span>Como funciona a Newsletter da Chico Rei?</span>
                            <span class="toggle-description">{{
                                showNewsletter ? '(ocultar)' : '(mostrar)'
                            }}</span>
                        </div>
                        <div class="description-content my-2" :class="{ visible: showNewsletter }">
                            <p class="my-2">
                                A News é um jeito especial da gente ficar ainda mais próximo! Após
                                se inscrever, você passa a receber todas as novidades sobre a marca,
                                como lançamentos, promoções, conteúdos exclusivos e ações especiais
                                para nossos assinantes em datas comemorativas. 
                            </p>
                            <p class="my-2">
                                Além disso, é possível selecionar o conteúdo que você deseja receber
                                e acompanhar de perto tudo o que acontece por aqui.
                            </p>
                        </div>
                    </div>
                    <div class="h-text-divider" />
                    <div id="description-basicas" class="my-0">
                        <div class="description-title" @click="showShipping = !showShipping">
                            <span>A Chico Rei tem frete grátis?</span>
                            <span class="toggle-description">{{
                                showShipping ? '(ocultar)' : '(mostrar)'
                            }}</span>
                        </div>
                        <div class="description-content my-2" :class="{ visible: showShipping }">
                            <p class="my-2">
                                Se você já está cadastrado em nossa base é só escolher o cupom de
                                desconto de sua preferência e pronto, ele será inserido na sua
                                sacola de compras automaticamente.
                            </p>
                            <p class="my-2">
                                Agora, se você ainda não possui cadastro em nosso site, você só
                                precisa informar o seu endereço de e-mail após escolher o cupom.
                                Feito isso, ele também será automaticamente inserido em sua sacola
                                de compras.
                            </p>
                            <p class="my-2">
                                Mas atenção: os cupons não são cumulativos com outros descontos e
                                promoções da Chico Rei.
                            </p>
                        </div>
                    </div>
                    <div class="h-text-divider" />
                    <div id="description-basicas" class="my-0">
                        <div class="description-title" @click="showReliable = !showReliable">
                            <span>A Chico Rei é confiável?</span>
                            <span class="toggle-description">{{
                                showReliable ? '(ocultar)' : '(mostrar)'
                            }}</span>
                        </div>
                        <div class="description-content my-2" :class="{ visible: showReliable }">
                            <p class="my-2">
                                Sim, pode confiar na gente! Mais de uma década de história no
                                comércio eletrônico e mais de 300 mil clientes atestam nossa
                                responsabilidade para garantir a sua segurança. Temos certificados
                                diversos e, inclusive, uma página inteira dedicada a explicar e
                                esclarecer qualquer dúvida que possa surgir na hora de comprar na
                                Chico Rei: https://chicorei.com/seguranca
                            </p>
                        </div>
                    </div>
                    <div class="h-text-divider" />
                    <div id="description-basicas" class="my-0">
                        <div class="description-title" @click="showBestPrices = !showBestPrices">
                            <span>Como encontrar os melhores preços em nosso site?</span>
                            <span class="toggle-description">{{
                                showBestPrices ? '(ocultar)' : '(mostrar)'
                            }}</span>
                        </div>
                        <div class="description-content my-2" :class="{ visible: showBestPrices }">
                            <p class="my-2">
                                No canto esquerdo das páginas de produtos você encontra os nossos
                                filtros. Um deles separa os produtos especificamente por valor! Se
                                você estiver caçando pechinchas é só selecionar o filtro com o valor
                                mais baixo e pronto: os produtos mais baratos daquela categoria vão
                                aparecer! E você também pode ordenar os produtos por preço, se
                                preferir.
                            </p>
                        </div>
                    </div>
                    <div class="h-text-divider" />
                </div>
            </div>
            <div class="section-basicas">
                <div id="description-basicas" class="my-0">
                    <div
                        class="description-title"
                        @click="showPreBlackContent = !showPreBlackContent"
                    >
                        <span>Fique por dentro de tudo dessa Black Friday</span>
                        <span class="toggle-description">{{
                            showPreBlackContent ? '(ocultar)' : '(mostrar)'
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div id="pre-black-wrapper" class="px-0" v-if="showPreBlackContent">
            <PreBlackContent />
            <PreBlackProductList />
        </div>
    </div>
</template>

<script>
    import PreBlackContent from '../pre-black-friday/content/PreBlackContent.vue';
    import PreBlackProductList from '../pre-black-friday/content/PreBlackProductList.vue';
    import { scrollToPosition } from '../../../common/common';

    export default {
        name: 'BlackFriday2023',
        el: '#black-friday-2023-vue',
        components: {
            PreBlackContent,
            PreBlackProductList,
        },

        mounted() {
            const observerOptions = {
                root: null,
                rootMargin: '-20px',
                threshold: 1,
            };
            scrollToPosition(0, 0);

            const titulo = document.querySelector('#banner-title');
            const observer = new IntersectionObserver(this.handleIntersection, observerOptions);
            observer.observe(titulo);
            const headerList = document.querySelectorAll(
                '#header-desktop-topbar-wrapper, #header-mobile-topbar-wrapper'
            );

            this.headerMobile = document.querySelector('#header-mobile');
            this.headerDesktop = document.querySelector('#header-desktop');

            headerList.forEach((element) => {
                element.addEventListener('mouseenter', this.onMouseEnter);
                element.addEventListener('mouseleave', this.OnMouseLeave);
            });
        },
        methods: {
            handleIntersection(entries) {
                this.titulo = entries[0];
                this.titulo.isIntersecting
                    ? this.switchHeader({
                          transparentBackground: true,
                      })
                    : this.switchHeader({
                          transparentBackground: false,
                      });
            },
            onMouseEnter() {
                this.switchHeader({ transparentBackground: false });
            },
            OnMouseLeave() {
                this.titulo.isIntersecting && this.switchHeader({ transparentBackground: true });
            },
            switchHeader({ transparentBackground }) {
                this.headerMobile.classList.toggle(
                    'transparent-header-hotsite',
                    transparentBackground
                );
                this.headerDesktop.classList.toggle(
                    'transparent-header-hotsite',
                    transparentBackground
                );

                this.headerMobile.classList.toggle('solid-header-hotsite', !transparentBackground);
                this.headerDesktop.classList.toggle('solid-header-hotsite', !transparentBackground);
            },
            scrollToProducts() {
                cr$.byId('content-basicas').scrollIntoView();
            },
        },

        data() {
            return {
                showCoupon: false,
                showNewsletter: false,
                showShipping: false,
                showReliable: false,
                showBestPrices: false,
                showPreBlackContent: false,

                bannerMain: {
                    image: {
                        desktop:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/black-friday-promo-vigente.png?auto=compress,format&q=65&h=800&w=1920&fit=clamp`,
                        mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2023/durante-black/banner_topo_promovigente_1_412x740.png?auto=compress,format&q=65&w=412&h=600&fit=crop`,
                    },
                },
                bannerTopSelling: {
                    image: {
                        desktop:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/sucessos-black-friday-camisetas-2.png?auto=compress,format&q=65`,
                        mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/sucessos-black-friday-camisetas-mobile-2.png?auto=compress,format&q=65`,
                    },
                    url: `/black-friday/sucessos`,
                },
                aboutUs: {
                    image:
                        this.$scope.CDN_IMAGES +
                        `/images/hotsites/blackfriday-2023/durante-black/sobre-a-chico.jpeg?auto=compress,format&q=65`,
                },
                mainProducts: [
                    {
                        text: `Ver camisetas de cultura brasileira`,
                        url: `/camiseta/brasilidade/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-brasilidade-1-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetsa-brasilidade-1.png?auto=compress,format`,
                    },
                    {
                        text: `Ver camisetas de filmes`,
                        url: `/camiseta/cinema/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-cinema-2-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-cinema-2.png?auto=compress,format`,
                    },
                    {
                        text: `Ver camisetas geek`,
                        url: `/camiseta/geek/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-geek-3-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-geek-3.png?auto=compress,format`,
                    },

                    {
                        text: `Ver camisetas engraçadas`,
                        url: `/camiseta/humor/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-humor-4-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-humor-4.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas de literatura`,
                        url: `/camiseta/literatura/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-literatura-5-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-literatura-5.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas de música`,
                        url: `/camiseta/musica/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-musica-6-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-musica-6.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas de séries`,
                        url: `/camiseta/series/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-series-7-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-serie-7.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas com frases`,
                        url: `/camiseta/tipografia/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-tipografia-8-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-tipografia-8.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                ],
                mainProductsOthers: [
                    {
                        text: `Ver mais canecas`,
                        url: `/promo/?tipo=17`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/canecas-4-2-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/canecas-4-2.png?auto=compress,format`,
                    },
                    {
                        text: `Ver mais posters`,
                        url: `/promo/?tipo=6`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/posters-6-2-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/posters-6-2.png?auto=compress,format`,
                    },
                    {
                        text: `Ver mais bandeiras`,
                        url: `/promo/?tipo=43`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/bandeiras-2-2-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/bandeiras-2-2.png?auto=compress,format`,
                    },

                    {
                        text: `Ver mais meias`,
                        url: `/promo/?tipo=33`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/meias-5-2-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/meias-5-2.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver mais bolsas`,
                        url: `/promo/?tipo=25`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/bolsas-3-2-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/bolsas-3-2.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver mais aventais`,
                        url: `/promo/?tipo=31`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/aventais-1-2-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/aventais-1-2.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver mais shorts`,
                        url: `/promo/?tipo=44`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/shorts-7-2-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/shorts-7-2.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver mais sketchbooks`,
                        url: `/promo/?tipo=18`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/sketchbooks-8-2-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/sketchbooks-8-2.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                ],
            };
        },
    };
</script>
